module.exports = __webpack_public_path__ + "static/media/icoInfo.9e68fb61.svg";